import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchErrorResults } from "../../services/errorResults";
import { STATUS } from "../../constants";

export const getAiErrorResults = createAsyncThunk("aiErrorResults/fetchAiErrorResults", async () => {
  const response = await fetchErrorResults(true);
  return response.data;
});

const aiErrorResultSlice = createSlice({
  name: "ai_error_results",
  initialState: { data: [], status: STATUS.DEFAULT },
  reducers: {},
  extraReducers: {
    [getAiErrorResults.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.status = STATUS.SUCCEED;
    },
    [getAiErrorResults.rejected]: (state) => {
      state.status = STATUS.FAILED;
    },
    [getAiErrorResults.pending]: (state) => {
      state.status = STATUS.LOADING;
    },
  },
});

export default aiErrorResultSlice;
